import Social, { SocialLink } from '@ui/social'
import Image from '@ui/image'
import {
  TeamMemberWrap,
  TeamMemberInner,
  TeamMemberImage,
  TeamMemberSocialWrap,
  TeamMemberInfo,
  TeamMemberName
} from './style'

const TeamMember = ({
  image,
  name,
  designation,
  socials = [],
  layout = 1,
  padding
}) => {
  return (
    <TeamMemberWrap $layout={layout}>
      <TeamMemberInner>
        <TeamMemberImage
          style={{ paddingLeft: padding || 0, paddingRight: padding || 0 }}
        >
          {image?.src && (
            <Image
              src={image.src.localFile || image.src}
              alt={image?.alt || name}
              sizes="(min-width: 768px) 400px, 100vw"
            />
          )}

          {socials?.length > 0 && (
            <TeamMemberSocialWrap>
              <Social
                color="light"
                variant="texted"
                tooltip
                tooltip_bg="secondary"
                hover={{ color: '#fff' }}
                space="20px"
                size="small"
              >
                {socials?.map(({ id, icon, link, title }) => (
                  <SocialLink key={id} title={title} path={link}>
                    <i className={icon} />
                  </SocialLink>
                ))}
              </Social>
            </TeamMemberSocialWrap>
          )}
        </TeamMemberImage>
        <TeamMemberInfo $layout={layout}>
          {name && (
            <TeamMemberName
              $layout={layout}
              dangerouslySetInnerHTML={{
                __html: name
              }}
            />
          )}
          {designation && (
            <p>
              <span
                dangerouslySetInnerHTML={{
                  __html: designation
                }}
              />
            </p>
          )}
        </TeamMemberInfo>
      </TeamMemberInner>
    </TeamMemberWrap>
  )
}

export default TeamMember
